import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import useStyles from './styles';
import { IFormErrorMessageProps } from '@components/FormErrorMesage/types';

const FormErrorMessage: React.FC<IFormErrorMessageProps> = ({ message, visible = false }) => {
  const css = useStyles();
  if (!visible) return null;
  return (
    <div data-testid="error-message-container" className={css.root}>
      <ErrorIcon data-testid="error-message-icon" /> {message}
    </div>
  );
};

export default FormErrorMessage;
